module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/babel-loader/lib/index.js!./FbtDriver.js"));
	}, "fbt");
}


//////////////////
// WEBPACK FOOTER
// ./src/features/fbt/driver/FbtDriver.js
// module id = 2002
// module chunks = 4